import Tyre from "./Tyre.jsx";
export default Tyre